import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_TASKS_LIST',
  'FETCH_TASK',
  'FETCH_TASK_STATE',
  'CREATE_TASK',
  'CLONE_TASK',
  'CANCEL_TASK',
]);
